import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { inject } from '@angular/core';

import { SessionRepository } from '../repositories/session.repository';

export const authGuard: CanActivateFn = async (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const sessionRepository = inject(SessionRepository);

  if (sessionRepository.user() != null) return true;

  try {
    await sessionRepository.getCurrentUser();
    return true;
  } catch (e) {
    setTimeout(() => {
      throw e;
    });
    return router.parseUrl(`/login?returnUrl=${encodeURIComponent(state.url)}`);
  }
};
